import { useState } from "react";
import { useNavigate } from "react-router";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/lib/auth-context";
import { api } from "@/lib/api";

/**
 * Persistent chrome while a Super Admin session is impersonating another user.
 * Exit restores the real ncdLabs session via POST /api/platform/impersonation/exit.
 */
export function ImpersonationBanner() {
  const { impersonation, refresh } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (!impersonation) return null;

  return (
    <div
      className="sticky top-0 z-[60] flex flex-wrap items-center justify-between gap-3 border-b border-rs-danger bg-rs-danger-soft px-4 py-2.5 text-sm text-rs-danger"
      role="status"
    >
      <p>
        Impersonating{" "}
        <strong className="font-semibold text-rs-ink">
          {impersonation.targetDisplayName}
        </strong>{" "}
        ({impersonation.targetEmail}) as {impersonation.impersonatorDisplayName}
        . Workspace actions run as the target user.
        {error ? <span className="ml-2 text-rs-danger"> {error}</span> : null}
      </p>
      <Button
        type="button"
        size="sm"
        variant="secondary"
        disabled={busy}
        onClick={() => {
          setBusy(true);
          setError(null);
          void api("/api/platform/impersonation/exit", { method: "POST" })
            .then(() => refresh())
            .then(() => navigate("/superadmin/users"))
            .catch((err) => {
              setError(err instanceof Error ? err.message : "Exit failed");
            })
            .finally(() => setBusy(false));
        }}
      >
        Exit Impersonation
      </Button>
    </div>
  );
}
